import { DOMNode } from 'html-react-parser';

const invalidCssDeclarationRegex = /([0-9]{1,}):.*/;
const cssDeclarationsSplitter = ';';

/**
 * Replacer function for dropping invalid CSS properties in `style` attribute.
 *
 * @param domNode The node that is being parsed.
 */
export function dropInvalidInlineStyleAttributeProperties(
  domNode: DOMNode,
): DOMNode {
  if ('attribs' in domNode && 'style' in domNode.attribs) {
    domNode.attribs.style = domNode.attribs.style
      .split(cssDeclarationsSplitter)
      .map((declaration) => {
        if (!declaration.match(invalidCssDeclarationRegex)) {
          if (declaration.endsWith('!important')) {
            // html-react-parser does not support !important, so we drop it
            return declaration.replace('!important', '').trim();
          }

          return declaration;
        }
      })
      .filter(Boolean)
      .join(cssDeclarationsSplitter);
  }

  return domNode;
}
